import { config } from "../config/config";
import { getAppState } from "../state";
import { getAddonsListWithBase } from "./layoutService";
import { getSdk } from "./sdkService";

export async function getSponsorBug(title) {
  const adUnit = config.get().sponsorAds.bug.URL;
  const size = config.get().sponsorAds.bug.size;
  const genres = title?.tagList?.genres?.join(",");
  const userStatus = getAppState().isSvodUser ? "active" : "inactive";

  try {
    const data = await getSdk().analyticsManager.getSponsorBug(adUnit, size, {
      titleId: title?.id,
      title: title?.title,
      assetType: title?.assetTypes.length > 0 && title?.assetTypes[0],
      genres,
      env: process.env.NODE_ENV === "development" || window.location.href.includes("stg") ? "test" : "prod",
      userStatus,
      ...(title.contentOwnership &&
        title.contentOwnership.length > 0 && { contentOwnership: title?.contentOwnership[0] }),
      entitlements: getAddonsListWithBase()
    });
    return data;
  } catch (error) {
    console.log("error: ", error);
  }
}

export async function getPauseAd(title) {
  const adUnit = config.get().sponsorAds.pauseAd.URL;
  const size = config.get().sponsorAds.pauseAd.size;
  const genres = title.isLiveContent ? title.genres?.join(",") : title?.tagList?.genres?.join(",");
  const userStatus = getAppState().userAccountStatus ? "active" : "inactive";

  try {
    const data = await getSdk().analyticsManager.getSponsorBug(adUnit, size, {
      titleId: title?.id,
      title: title?.title,
      assetType: title?.assetTypes.length > 0 && title?.assetTypes[0],
      genres,
      env: process.env.NODE_ENV === "development" || window.location.href.includes("stg") ? "test" : "prod",
      ...(title.ecommerceAds && { ecommerceAds: true }),
      userStatus,
      ...(title.contentOwnership &&
        title.contentOwnership.length > 0 && { contentOwnership: title?.contentOwnership[0] }),
      entitlements: getAddonsListWithBase()
    });
    return data;
  } catch (error) {
    console.log("error: ", error);
  }
}

export async function impressionTracking(url) {
  await getSdk().analyticsManager.impressionTracking(url);
}
